export default {
  views: {
    subGroups: {
      assign: "Назначить подгруппы",
      tagManager: "Диспетчер тегов: выберите свою группу",
      successAssign: "Отлично! Вы обновили подгруппы для своей группы.",

      errors: {
        assign: "О, о! Невозможно назначить подгруппу"
      },

      table: {
        firstName: "Имя",
        lastName: "Фамилия",
        username: "Имя пользователя",
        subGroup: "Подгруппа"
      }
    },

    classes: {
      label: "Группа",

      editGroup: "Изменение группы: шаг {step}",
      addGroup: "Добавление группы: шаг {step}",
      classesCount: "{count} groups",

      errors: {
        group: "Не удалось загрузить данные группы.",
        update: "Не удалось обновить группу. Повторите попытку позже",
        create: "Не удалось создать группу",
        emptyList: "У вас еще нет групп в выбранной школе."
      },

      messages: {
        create: "Группа создана!"
      }
    },

    schools: {
      label: "Школа",

      errors: {
        emptyList: "У вас нет доступных школ.",
        fetchError: "Не удалось получить информацию о школах"
      }
    },

    teachers: {
      teachersCount: "{count} учителя",

      errors: {
        emptyList: "У вас еще нет учителей.",
        details: "Не удалось получить данные об учителе."
      },

      titles: {
        edit: "Изменить учителя"
      },

      messages: {
        create: "Учитель добавлен!",
        update: "Учитель обновлен!"
      }
    },

    grammarToGo: {
      title: "Полезная грамматика"
    },

    home: {
      wantToAssign: "Я хочу назначить урок",
      whatStudentsDo: "Чем ваши ученики занимаются в Little Bridge?",
      howManyCountries: "Во скольких странах есть DigiPal у ваших учеников?",
      numActivities: "Сколько заданий выполнили ваши ученики?",
      numFriends: "Сколько друзей DigiPal у ваших учеников?",
      numMessages: "Сколько сообщений отправили ваши ученики?",

      errors: {
        dashboard: "Не удалось получить данные личного кабинета."
      }
    },

    knowledgeBase: {
      title: "База знаний",

      errors: {
        fetch: "Не удалось получить базу знаний",
        details: "Не удалось получить информацию о базе знаний"
      }
    },

    lessons: {
      label: "Урок",

      subgroups: "Подгруппы",

      messages: {
        setLessonsAuto:
          "Little Bridge теперь автоматически назначает уроки для ваших учеников. Они будут обучаться в удобном для них темпе. Вы можете  в любое время изменить эту настройку, назначив урок для своих учеников."
      },

      hasBeenAssigned: "Этот урок назначен.",
      assignAnother: "Назначить еще один урок",
      assignMyself: "Я хочу назначать уроки самостоятельно",
      assignAuto:
        "Я хочу, чтобы платформа Little Bridge назначала уроки автоматически",
      lessonId: "Урок {lessonId}",
      set: "Настроить урок",
      activity: "Мероприятия",
      resources: "Ресурсы",

      statuses: {
        selected: "Урок выбран",
        archived: "Добавлено в архив",
        current: "Текущий урок",
        unassigned: "Не назначен"
      },

      stepper: {
        titles: {
          step1: "Шаг 1. Для кого вы хотите назначить урок?",
          step2: "Шаг 2. Выбор урока",
          step3: "Шаг 3. Подтверждение"
        }
      },

      errors: {
        fetch: "Не удалось получить информацию об уроках."
      }
    },

    reports: {
      title: "Генератор отчетов",
      type: "Тип отчета",
      generate: "Сгенерировать отчет",

      level: "Отчет об уровне",
      lesson: "Отчет об уроке",
      test: "Отчет об оценке",
      diagnostic: "Диагностический отчет",
      baseline: "Базовый отчет",
      progress: "Тест прогресса",
      students: "студенты",

      download: {
        pdf: "Загрузить в формате PDF",
        csv: "Загрузить в формате CSV",
        lessonPlan: "Загрузить план урока в формате PDF"
      },

      errors: {
        generate: "Не удалось сгенерировать отчет. Повторите попытку позже."
      }
    },

    students: {
      label: "Студенты",
      editStudent: "Редактировать студента",
      stundentsCount: "{count} студенты",
      add: "Добавить ученика",
      saveAndDownload: "Сохранение и загрузка списка учеников",
      download: "Загрузить список учеников",

      import: {
        step: "Шаг: Импорт студентов: шаг ",
        clickVideo: "Нажмите здесь, чтобы посмотреть короткое обучающее видео",
        copyPasteFirst:
          "Скопируйте и вставьте имена учеников в текстовое поле «Имя».Можно импортировать до 100 учеников одновременно.",
        copyPasteLast:
          "Скопируйте и вставьте фамилии учеников в текстовое поле «Фамилия».",
        confirm:
          "Прекрасно! Теперь убедимся, что все правильно. Вы можете вернуться на предыдущую страницу, если хотите внести изменения. Убедитесь, что имена и фамилии каждого ученика совпадают.",
        thoseStudentsAdded:
          "Эти ученики были добавлены в ваш аккаунт. По соображениям безопасности вы не можете загружать пароли повторно. Убедитесь, что вы сохранили предоставленный файл в безопасном месте. Если файл не загрузился автоматически, нажмите кнопку «Загрузить список учеников».",
        note: "Примечание. На импорт существует ограничение в 100 студентов."
      },

      messages: {
        create: "Ученик добавлен!",
        update: "Ученик обновлен!"
      },

      errors: {
        emptyList: "У вас еще нет учеников.",
        details: "Не удалось получить данные об ученике.",
        import:
          "Ой! Что-то пошло не так. Попробуйте еще раз скопировать и вставить имена и фамилии.",
        importPaste: "Ой! Вы не вставили информацию в столбец."
      }
    }
  },

  stepsLabels: {
    step4: "Шаг 4. Подтверждение"
  },

  common: {
    next: "Далее",
    ok: "ОК",
    unassigned: "Не назначен",
    close: "Закрыть",
    nextConfirm: "Следующий шаг — подтверждение",
    continue: "Продолжить",
    returnHome: "Назад на главную страницу",
    finish: "Завершить",
    confirm: "Подтвердить",
    save: "Сохранить",
    siteUsage: "Использование сайта",
    reset: "Сброс настроек"
  },

  errors: {
    basic: "Не удалось загрузить данные..",
    unexpected: "Произошла непредвиденная ошибка.",
    admin:
      "Ой! Вы не авторизованы для этого действия. Обратитесь к администратору."
  },

  tables: {
    lessons: {
      level: "Уровень",
      topic: "Тема",
      lesson: "Урок",
      summary: "Краткая информация",
      content: "Материалы",
      status: "Статус",
      testCategory: "Категория теста"
    },

    reports: {
      firstName: "Имя",
      lastName: "Фамилия",
      username: "Имя пользователя",
      lesson: "Урок",
      scoreForActivity: "Оценка - {activityId}",
      correct: "Верно",
      topic: "Тема",
      progress: "Прогресс",
      levelNumber: "Уровень",
      lessonName: "Название урока",
      activity1: "Задание 1",
      activity2: "Задание 2",
      activity3: "Задание 3",
      activity4: "Задание 4"
    },

    classes: {
      group: "Группа",
      subgroups: "Подгруппы",
      teacher: "Учитель",
      numberOfStudents: "Количество учеников",
      lesson: "Текущий урок",

      errors: {
        failedDelete: "Не удалось удалить группу(-ы). Повторите попытку позже.",
        canBeAssign:
          "Ученики могут быть назначены только для одной группы за раз. Все ученики, назначенные в эту группу, будут удалены из текущей группы."
      }
    }
  },

  components: {
    noActivitiesInLesson: "В этом уроке нет заданий.",
    selectAll: "Выбрать все",
    groupName: "Название группы",
    assignStudents: "Следующий шаг — назначение учеников",
    assignTeachers: "Следующий шаг — назначение учителей",
    noData: "Нет доступных данных.",
    videoSupport: "К сожалению, ваш браузер не поддерживает встроенные видео.",
    generateUsername: "Создать новое имя пользователя",
    password: "Пароль",
    admin: "Администратор",
    view: "Вид",
    goBack: "Вернитесь назад",
    openLanguageMenu: "Открыть языковое меню",
    isAdmin: "Админ",
    selectALevel: "Выберите уровень",

    warnings: {
      deleteClasses: "Вы собираетесь удалить классы {clasessNames}"
    },

    errors: {
      selectGroups: "Сначала выберите группы.",
      editOneGroupAtOnce: "Можно изменить только 1 группу за раз",

      selectStudents: "Сначала выберите учеников.",
      deleteStudents: "Вы собираетесь удалить учеников {studentsNames}",
      editOneStudentAtOnce: "Можно изменить только 1 ученика за раз",
      failedToDeleteStudents:
        "Не удалось удалить ученика(-ов). Повторите попытку позже.",
      selectTeachers: "Сначала выберите учителей.",
      deleteTeachers: "Вы собираетесь удалить учителей",
      editOneTeacherAtOnce: "Можно изменить только 1 учителя за раз",
      failedToDeleteTeachers:
        "Не удалось удалить учителя(-ей). Повторите попытку позже.",
      teacherNames: "Пожалуйста, укажите имя и фамилию учителя.",
      failedUsername: "Не удалось создать имя пользователя. Попробуйте позже.",
      teacherEdit: "Невозможно изменить имя пользователя учителя"
    }
  },

  navigation: {
    subgroups: "Назначить подгруппы",
    open: "Открыть меню",
    goToDashboard: "Перейти в личный кабинет учителя",
    teachers: "Учителя",
    students: "Ученики",
    lessons: "Уроки",
    groups: "Группы",
    reports: "Генератор отчетов",
    grammar: "Полезная грамматика",
    knowledge: "База знаний",
    logout: "Выйти"
  }
};
